import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Content } from "../Components/Typo";
import { Title, Subtitle, Paragraph } from "../Components/styled/Typo";
import { Link } from "react-router-dom";
import { Fade, Modal } from "@mui/material";
import { BsBox } from "react-icons/bs";
import { Column } from "../Components/styled/Layout";
import {
  ScrollContainer,
  ScrollPage,
  Sticky,
  MoveOut,
  batch,
  Animator,
} from "react-scroll-motion";
import { NextButton, BlockButton } from "../Components/styled/Button";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import { motion } from "framer-motion";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  cursor: all-scroll;
`;

const Description = styled.div`
  color: #000;
  width: 50vw;
  height: 100vh;
  background-color: #fff;
  border-bottom: 1px solid #000;
  padding-left: 50px;
  padding-right: 50px;
`;

// const Illustration = styled.div`
//   width: 50vw;
//   background-image: ${(props) => `url("${props.url}")`};
//   background-position: center;
//   background-size: cover;
//   object-fit: cover;
//   object-position: center top;
//   background-position: center;
//   height: 100vh;
// `;

export const IllustrationVideo = styled.video`
  width: 50vw;
  object-fit: cover;
  object-position: center top;
  height: 100vh;
`;

const TitleStyled = styled(Title)`
  text-align: center;
  margin-top: 60px;
`;
const Center = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

const Icon = styled(BsBox)`
  font-weight: bold;
`;

const Button = styled(Link)`
  cursor: pointer;
  justify-self: center;
  width: 250px;
  border-radius: 25px;
  margin-top: 15px;
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  border: 2px solid #000;
  backdrop-filter: blur(15px);
  color: #000;
  transition: all 0.5s;
  :hover {
    background-color: #000;
    color: #fff;
  }
`;

const CustomLink = styled(Link)`
  padding: 7px;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  width: 175px;
  font-weight: bold;
  text-decoration: none;
  border-radius: 20px;
  border: 2px solid #000;
  backdrop-filter: blur(15px);
  color: #000;
  transition: all 0.5s;
  font-size: 14px;
  :hover {
    background-color: #000;
    color: #fff;
  }
`;

const Item = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 5px;
`;

const ItemDescription = styled(Content)`
  margin: 0px;
`;

const Image = styled.img`
  width: 150px;
  height: 75px;
  cursor: zoom-in;
  object-fit: cover;
  margin: 5px;
  margin-right: 15px;
  border: ${(props) => (props.bordering ? "2px red solid" : "0px red solid")};
`;

const Background = styled.img`
  position: absolute;
  display: block;
  object-fit: cover;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 650px;
  height: 450px;
  border-radius: 10px;
`;

const ModalStyled = styled(Modal)`
  backdrop-filter: blur(2px);
`;

const ItemTitle = styled(Subtitle)`
  font-size: 16px;
`;

export default function ParkerDescription() {
  const videoRef = useRef();
  const videoRef2 = useRef();
  const [url, setUrl] = useState(null);
  const { t } = useTranslation();
  const data = [
    {
      title: "Eugene Parker",
      src: "parker.jpg",
      alt: "parker probe dimension",
      content: t(`parkerContent1`),
    },
  ];

  useEffect(() => {
    if (videoRef.current && !videoRef.current.playing) {
      videoRef.current.play();
    }
    if (videoRef2.current && !videoRef2.current.playing) {
      videoRef2.current.play();
    }
  }, []);

  useEffect(() => {
    document.body.style.overflow = "auto";
  }, []);
  return (
    <>
      <ModalStyled
        open={url !== null}
        onClose={() => setUrl(null)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Background src={url} />
      </ModalStyled>

      <Section id="onet">
        <IllustrationVideo
          ref={(ref) => (videoRef.current = ref)}
          muted={true}
          controls={false}
          autoPlay={true}
          loop={true}
          preload="auto"
        >
          <source src="video2.mp4" type="video/mp4" />
        </IllustrationVideo>
        <CardContainer>
          <Column>
            <Title style={{ color: "#141414" }}>{t("parkerTitle")}</Title>
            <Subtitle style={{ color: "#141414", fontSize: ".9rem" }}>
              {t("parkerDescription1")}
            </Subtitle>
            <ButtonProbe to="/parker-probe">
              <Icon size="16px" /> SEE 3D MODEL
            </ButtonProbe>
            <Box>
              <hr />
              {data.map((item) => {
                return (
                  <>
                    <CardUser onClick={() => setUrl(item.src)}>
                      <Img src={item.src} alt={item.alt} />
                      <Paragraph>{item.content}</Paragraph>
                    </CardUser>
                    {/* <ItemTitle>{item.title}</ItemTitle> */}
                  </>
                );
              })}
            </Box>
          </Column>
          <BlockButton style={{ marginTop: 25 }}>
            <NextButton to={"/solar"}>
              <FaAngleLeft />
            </NextButton>
            <NextButton
              onClick={() => {
                document.getElementById("twot").scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                  inline: "center",
                });
              }}
            >
              <FaAngleRight />
            </NextButton>
          </BlockButton>
        </CardContainer>
      </Section>

      <Section id="twot">
        <IllustrationVideo
          ref={(ref) => (videoRef.current = ref)}
          muted={true}
          controls={false}
          autoPlay={true}
          loop={true}
          preload="auto"
        >
          <source src="video3.mp4" type="video/mp4" />
        </IllustrationVideo>
        <CardContainer>
          <Column>
            <CardParagraph>
              <Title style={{ color: "#141414" }}>
                Why won't the Parker solar probe melt?
              </Title>
              <Paragraph>
                {" "}
                Parker Solar Probe has been designed to withstand the extreme
                conditions and temperature fluctuations for the mission. The key
                lies in its custom heat shield and an autonomous system that
                helps protect the mission from the Sun’s intense light emission,
                but does allow the coronal material to “touch” the spacecraft.
              </Paragraph>
            </CardParagraph>

            <CardParagraph>
              <Title style={{ color: "#141414" }}>Communication problems</Title>
              <Paragraph>
                {" "}
                It takes light eight minutes to reach Earth — meaning if
                engineers had to control the spacecraft from Earth, by the time
                something went wrong it would be too late to correct it.
              </Paragraph>
              <Paragraph>
                {" "}
                So, the spacecraft is designed to autonomously keep itself safe
                and on track to the Sun. Several sensors, about half the size of
                a cell phone, are attached to the body of the spacecraft along
                the edge of the shadow from the heat shield.
              </Paragraph>
            </CardParagraph>
          </Column>
          <BlockButton style={{ marginTop: 25 }}>
            <NextButton
              onClick={() => {
                document.getElementById("onet").scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                  inline: "center",
                });
              }}
            >
              <FaAngleLeft />
            </NextButton>
            <NextButton
              onClick={() => {
                document.getElementById("threet").scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                  inline: "center",
                });
              }}
            >
              <FaAngleRight />
            </NextButton>
          </BlockButton>
        </CardContainer>
      </Section>

      <Section id="threet">
        <IllustrationVideo
          ref={(ref) => (videoRef.current = ref)}
          muted={true}
          controls={false}
          autoPlay={true}
          loop={true}
          preload="auto"
        >
          <source src="video4.mp4" type="video/mp4" />
        </IllustrationVideo>
        <CardContainer>
          <Column>
            <CardParagraph>
              <Title style={{ color: "#141414" }}>Accomplishment</Title>
              <Paragraph>
                {" "}
                NASA's Parker Solar Probe launched on August 12, 2018 aboard a
                United Launch Alliance Delta IV Heavy rocket. Parker Solar
                Probe's mission is to study the sun in unprecedented detail.
                Three years after its launch, NASA's Parker Solar Probe has now
                flown past the Sun's upper atmosphere - the corona - and sampled
                particles and magnetic fields there.
              </Paragraph>
            </CardParagraph>

            <CardParagraph>
              <Paragraph>
                {" "}
                On its 10th close solar flyby on Nov. 21, 2021, the sun's
                powerful gravity accelerated the probe to a top speed of 101
                miles (163 kilometers) per second, which translates to an
                astonishing speed of 364,621 mph (586,000 kph). It's faster than
                any probe has ever traveled before.
              </Paragraph>
            </CardParagraph>
            <CardParagraph>
              <Paragraph>
                So, the spacecraft is designed to autonomously keep itself safe
                and on track to the Sun. Several sensors, about half the size of
                a cell phone, are attached to the body of the spacecraft along
                the edge of the shadow from the heat shield.
              </Paragraph>
            </CardParagraph>
          </Column>
          <BlockButton style={{ marginTop: 25 }}>
            <NextButton
              onClick={() => {
                document.getElementById("twot").scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                  inline: "center",
                });
              }}
            >
              <FaAngleLeft />
            </NextButton>
            <NextButton
              onClick={() => {
                document.getElementById("fourt").scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                  inline: "center",
                });
              }}
            >
              <FaAngleRight />
            </NextButton>
          </BlockButton>
        </CardContainer>
      </Section>

      <Section id="fourt">
        <IllustrationVideo
          ref={(ref) => (videoRef.current = ref)}
          muted={true}
          controls={false}
          autoPlay={true}
          loop={true}
          preload="auto"
        >
          <source src="video3.mp4" type="video/mp4" />
        </IllustrationVideo>
        <CardContainer>
          <Column>
            <CardParagraph>
              <Paragraph>
                {" "}
                Parker Solar Probe will answer questions about solar physics
                that have puzzled us for over six decades, including why the
                sun's corona is so hot.
              </Paragraph>
            </CardParagraph>
            <CardParagraph>
              <Paragraph>
                Just as landing on the Moon allowed scientists to understand how
                it was formed, touching the very stuff the Sun is made of will
                help scientists uncover critical information about our closest
                star and its influence on the solar system.
              </Paragraph>
            </CardParagraph>
          </Column>
          <BlockButton style={{ marginTop: 120 }}>
            <NextButton
              onClick={() => {
                document.getElementById("threet").scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                  inline: "center",
                });
              }}
            >
              <FaAngleLeft />
            </NextButton>
            <NextButton to={"/summary"}>
              <FaAngleRight />
            </NextButton>
          </BlockButton>
        </CardContainer>
      </Section>
    </>
  );
}

export const Section = styled.div`
  display: grid;
  height: 100vh;
  grid-template-columns: 1fr 1fr;
`;

export const CardContainer = styled.div`
  background: #d6f8f633;
  backdrop-filter: blur(25px);
  padding: 20px;
`;

export const ButtonProbe = styled(Link)`
  width: 100%;
  height: 45px;

  border: 1px solid #141414;
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  gap: 10px;
  font-weight: 600px;
  border-radius: 5px;
  transition: linear 0.4s;
  background: transparent;
  backdrop-filter: blur(25px);
  color: #141414;
  box-shadow: inset 0.5px 3px 6px rgba(0, 0, 0, 0.2);

  &:hover {
    background-color: #141414;
    color: #fff;
    box-shadow: 0.5px 3px 6px rgba(0, 0, 0, 0.2);
  }
`;

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  align-items: center;
  justify-content: center;
`;

export const CardUser = styled.div`
  width: 100%;
  padding: 20px;
  display: flex;
  gap: 20px;
  box-shadow: 0.5px 3px 6px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  margin-top: 10px;
  transition: linear 0.4s;
  cursor: pointer;

  &:hover {
    box-shadow: 1px 6px 9px rgba(0, 0, 0, 0.2);
  }
`;

export const Img = styled.img`
  width: 150px;
  height: 100%;
  object-fit: cover;
  object-position: center;
  border-radius: 5px;
`;

export const CardParagraph = styled.div`
  width: 100%;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  box-shadow: 0.5px 3px 6px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  margin-top: 10px;
  transition: linear 0.4s;

  &:hover {
    box-shadow: 1px 6px 9px rgba(0, 0, 0, 0.2);
  }
`;
